export enum SettingsTypeEnum {
  Email = 'emailNotification',
  Platform = 'platformNotification',
}
